<template>
    <div>
      <vue-headful
      title="Dashboard | Create Link In Bio"
      description="Dashboard | Create Link In Bio"
  />
  
      <div>
          <nav style="position: fixed;width: 100%;height: 71px;background: #ffffff;border-bottom: 1px solid #dde1ed;z-index: 99;">
              <div style="display: flex;align-items: center;height: 100%;justify-content: space-between;margin-left: 20px;margin-right: 20px;">
                  <button @click="back" class="btn btn-light"><i class="fa-solid fa-chevron-left mr-2"></i> Back</button>
              </div>
          </nav>
  
  
  
  
  
          <div v-if="loading_logos" style="margin: 0 auto;" class="pt-7">
            <center>
                <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
                <p class="lead">Loading...</p>
            </center>
          </div>
          <div v-else class="container">
            <!-- STEP 1 -->
            <div v-if="step === '1'" class="pt-7">
                <progress value="1.5" max="4" class="w-100 mb-3">Step 1 of 4</progress>
                <h1>Select your brand</h1>
                <p class="lead">Select the brand you want to use for your Email Signature.</p>
                <div class="row">
                    <div v-for="(logo, index) in logos" class="col-6 col-md-4 col-lg-3">
                        <div @click="choose_logo(logo.unique_id, logo.paid_svglogos_s3);" class="aumentarscale_btn" :class="{ 'selectedcontainer': logo_unique_id === logo.unique_id }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                            <div v-if="logo.paid_svglogos_s3 === 'needs_update'" class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                <img :src="'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+timenow" @load="checkContentHeight" style="width: 100%; border-radius: 5px;height: auto;">
                            </div>
                            <div v-else class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                <img :src="'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+timenow" @load="checkContentHeight" style="width: 100%; border-radius: 5px;height: auto;">
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{'fixed-button': isButtonFixed, 'p-0': !isButtonFixed}" class="container pb-3" id="continueButton">
                    <button class="btn btn-blue w-100" @click="continue_method">
                        Skip
                    </button>
                </div>
                <div v-if="isButtonFixed" class="spacer"></div> <!-- Spacer element -->
            </div>
            <!-- STEP 2 -->
            <div v-if="step === '2'" class="container-sm pt-7">
                <progress value="2.5" max="4" class="w-100 mb-3">Step 2 of 4</progress>
                <h2>Set up your link in bio</h2>
                <div class="mt-4 mb-3 d-flex align-items-center">
                    <h4 class="m-0">Basic information</h4>
                    <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #dbdbdb !important;"></div>
                </div>
                <div class="mb-3">
                    <p class="mb-2">Profile Image</p>
                    <div class="d-flex align-items-center">
                        <img v-if="!profile_image && !logo_unique_id" src="https://logo.app/assets/img/placeholder-image.jpg" alt="Profile Image" id="profileImage" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                        <img v-else-if="profile_image" :src="profile_image" alt="Profile Image" id="profileImage" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                        <img v-else-if="logo_unique_id && paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" id="profileImage" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                        <img v-else-if="logo_unique_id && paid_svglogos_s3 !== 'needs_update'" :src="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" id="profileImage" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                        <div>
                            <div class="btn btn-blue">
                                <label for="customFile" class="mb-0 text-white" style="cursor:pointer;">Change Image</label>
                                <input type="file" ref="la_profile_image" @change="UploadProfileImage" accept=".jpg, .jpeg, .png, .svg" name="image" id="customFile" class="d-none">
                            </div>
                            <button v-if="profile_image || logo_unique_id" @click="profile_image = ''; logo_unique_id = '';" class="btn btn-danger"><i class="fa-solid fa-trash-can"></i></button>
                        </div>
                        <p v-if="profile_image_error" style="color: #ff0000;">{{profile_image_error}}</p>
                    </div>
                    <small class="text-muted">Recommended Size 500x500</small>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2">
                        <p class="mb-2">Profile Title</p>
                        <input v-model="profile_title" type="text" id="business-name-input" placeholder="Your name or brand name" class="form-control">
                    </div>
                    <div class="col-12 col-md-6 pl-md-2">
                        <p class="mb-2">Description</p>
                        <input v-model="description" type="text" id="slogan-input" placeholder="Brief description" class="form-control">
                    </div>
                </div>
                <div class="mt-4 mb-3 d-flex align-items-center">
                    <h4 class="m-0">Add your links</h4>
                    <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #dbdbdb !important;"></div>
                </div>
                <div class="mb-5">
                    <draggable v-model="links" class="list-group" v-bind="{ handle: '.handle' }">
                        <div v-for="(link, index) in links" :key="index" class="mb-3 row align-items-center">
                            <div class="col-auto pr-0">
                                <div class="handle" style="cursor: grab;">
                                    <i class="fa-solid fa-bars"></i>
                                </div>
                            </div>
                            <div class="col form-group mb-0 pr-0">
                                <select class="custom-select" v-model="link.media" @change="updateMediaAndText(index)">
                                <option disabled value="">Choose Icon</option>
                                <option>Apple App Store</option>
                                <option>ArtStation</option>
                                <option>Behance</option>
                                <option>Discord</option>
                                <option>Facebook</option>
                                <option>GitHub</option>
                                <option>Google Play Store</option>
                                <option>Instagram</option>
                                <option>LinkedIn</option>
                                <option>Medium</option>
                                <option>Patreon</option>
                                <option>Pinterest</option>
                                <option>Reddit</option>
                                <option>Snapchat</option>
                                <option>TikTok</option>
                                <option>Tumblr</option>
                                <option>Twitch</option>
                                <option>Twitter</option>
                                <option>Vimeo</option>
                                <option>Weibo</option>
                                <option>WhatsApp</option>
                                <option>X</option>
                                <option>YouTube</option>
                                <option>Email</option>
                                <option>Globe</option>
                                </select>
                            </div>
                            <div class="col pt-md-0">
                                <input type="url" placeholder="https://example.com" class="form-control" v-model="link.url">
                            </div>
                            <div class="col-12 col-md-auto pl-md-0 pt-3 pt-md-0">
                                <button class="btn btn-danger w-100" @click="removeLink(index)"><i class="fa-solid fa-trash-can"></i></button>
                            </div>
                        </div>
                    </draggable>
                    <button class="btn btn-outline-blue w-100" @click="addLink">
                        <i class="fa-solid fa-plus mr-2"></i> Add Link
                    </button>
                </div>
                <div :class="{'fixed-button': isButtonFixed, 'p-0': !isButtonFixed}" class="container-sm pb-3" id="continueButton">
                    <button class="btn btn-success w-100" @click="continue_method">
                        Continue
                    </button>
                </div>
                <div v-if="isButtonFixed" class="spacer"></div> <!-- Spacer element -->
            </div>
            <!-- STEP 3 -->
            <div v-if="step === '3'" class="container-sm pt-7">
                <progress value="3.5" max="4" class="w-100 mb-3">Step 3 of 4</progress>
                <h1>Publish your link in bio!</h1>
                <p class="lead">Add a name that represents you, your business, or your brand to publish your page immediately.</p>
                <div class="input-group">
                    <span class="input-group-text" style="border-radius: 0.5rem 0px 0px 0.5rem;">brand.bio/</span>
                    <input v-model="username" maxlength="255" type="text" class="form-control form-control-lg p-2" placeholder="brandname" style="border-radius: 0px 0.5rem 0.5rem 0px;">
                </div>
                <p v-if="!username" class="mt-3 mb-0 text-blue">Please set the username for your link</p>
                <!-- This username is not available. -->
                <div v-if="username_unavailable && username" class="alert alert-danger border border-danger text-danger bg-white mt-3 mb-0" role="alert">
                    <i class="fa-solid fa-circle-xmark"></i> This username is not available.
                </div>
                <!-- This username has invalid characters. -->
                <div v-if="username_invalid_characters && username" class="alert alert-danger border border-danger text-danger bg-white mt-3 mb-0" role="alert">
                    <i class="fa-solid fa-circle-xmark"></i> Username can only contain letters, numbers, hyphens, and underscores. Please remove any spaces, dots, or special characters.
                </div>
                <div class="container-sm pt-3 pb-3 px-0">
                    <button v-if="!creating_link_in_bio" :disabled="!username" class="btn btn-success w-100" @click="continue_method">
                        Continue
                    </button>
                    <button v-else class="btn btn-success w-100">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="top: -2px;position: relative;"></span>
                    </button>
                </div>
            </div>
          </div>




    </div>
  
    </div>
  
  </template>

    <style>
    .fixed-button {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
    }
    .spacer {
        height: 58px; /* Height of the button + 1 */
        opacity: 0; /* Make it invisible */
    }
    </style>
    <script>
    import ClickOutside from 'vue-click-outside';

    export default {
      props:['propsdata'],
      data() {
        return {
          loading_logos: true,
          timenow: Date.now(),
          step: '1',
          logos: [],
          logo_unique_id: '',
          profile_image: '',
          profile_image_error: '',
          profile_title: '',
          description: '',
          links: [
            { media: '', text: '', url: '' }
          ],
          socialMediaBaseUrls: {
            'Apple App Store': 'https://apps.apple.com/',
            ArtStation: 'https://artstation.com/',
            Behance: 'https://behance.net/',
            Discord: 'https://discord.com/',
            Facebook: 'https://facebook.com/',
            GitHub: 'https://github.com/',
            'Google Play Store': 'https://play.google.com/',
            Instagram: 'https://instagram.com/',
            LinkedIn: 'https://linkedin.com/',
            Medium: 'https://medium.com/',
            Patreon: 'https://patreon.com/',
            Pinterest: 'https://pinterest.com/',
            Reddit: 'https://reddit.com/',
            Snapchat: 'https://snapchat.com/',
            TikTok: 'https://tiktok.com/',
            Tumblr: 'https://tumblr.com/',
            Twitch: 'https://twitch.tv/',
            Twitter: 'https://twitter.com/',
            Vimeo: 'https://vimeo.com/',
            Weibo: 'https://weibo.com/',
            WhatsApp: 'https://whatsapp.com/',
            X: 'https://x.com/',
            YouTube: 'https://youtube.com/',
            Email: 'mailto:',
            Globe: 'https://'
          },
          username: '',
          creating_link_in_bio: false,
          retry_axios: 1,
          isButtonFixed: false // Track if the button should be fixed
        };
      },
      components: {
        draggable: window['vuedraggable']
      },
      methods: {
        async load_logos(){
            // Wait until propsdata paid is populated
            while (this.propsdata[0].paid === '') {
                // Wait for 100ms before checking again
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            if(this.propsdata[0].paid === 'yes'){
                axios.post('/dashboard/cargar-logos-unique-id.php', {
                })
                .then(response => {
                    this.logos = response.data;
                    if(response.data === null || response.data.length <= 0){ //check if user has logos
                        this.step = '2';
                    }
                    this.loading_logos = false;
                    this.checkContentHeight(); //re-run follow function to re-arrange height
                })
                .catch(function (error) {
                console.log(error);
                });
            }
            else{
                this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
            }
        },
        back(){
            if(this.step === '1'){
                this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
            }
            else if(this.step === '2'){
                if(this.logos === null || this.logos.length <= 0){ //check if user has logos
                    this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
                }
                else{
                    this.step = '1';
                    this.checkContentHeight(); //re-run follow function to re-arrange height
                }
            }
            else if(this.step === '3'){
                this.step = '2';
                this.checkContentHeight(); //re-run follow function to re-arrange height
            }
        },
        choose_logo(unique_id, paid_svglogos_s3){
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = paid_svglogos_s3;
            this.profile_image = '';
            this.step = '2';
            this.checkContentHeight(); //re-run follow function to re-arrange height
        },
        UploadProfileImage(e) {
            this.profile_image_error = '';
            const file = e.target.files[0]; // Get the first file
            let reader = new FileReader();
            if (file['size'] < 2000000) {
                reader.onloadend = (file) => {
                    var landing = reader.result;
                    // console.log(reader.result);
                    this.profile_image = landing;
                    this.logo_unique_id = '';
                }
                reader.readAsDataURL(file);
            } else {
                this.profile_image_error = 'File is too big, please submit an image smaller than 2MB.';
            }
        },
        updateMediaAndText(index) {
            this.links[index].text = this.links[index].media;
        },
        addLink() {
            this.links.push({ media: '', text: '', url: '' });
        },
        removeLink(index) {
            this.links.splice(index, 1);
        },
        continue_method(){
            if(this.step === '1'){
                this.step = '2';
                this.checkContentHeight(); //re-run follow function to re-arrange height
            }
            else if(this.step === '2'){
                this.step = '3';
            }
            else if(this.step === '3'){
                if(!this.creating_link_in_bio){
                    this.creating_link_in_bio = true;
                    this.save_link_in_bio();
                }
            }
        },
        save_link_in_bio(){
            this.username_unavailable = false;
            this.username_invalid_characters = false;
            axios.post('/dashboard/save-link-in-bio.php', {
                username: this.username,
                profile_image: this.profile_image,
                logo_unique_id: this.logo_unique_id,
                profile_title: this.profile_title,
                description: this.description,
                links: this.links,
                background_color: '#ffffff',
                button_color: '#000000',
                button_text_color: '#ffffff',
                button_icon_color: '#ffffff',
                button_shadow_color: '#dddddd',
                button_style: '1',
                button_shape: '1',
                icon_color: '#000000',
                font_color: '#000000',
                powered_by: 'yes'
            })
            .then(response => {
                if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                    this.retry_axios = this.retry_axios+1;
                    this.save_link_in_bio();
                }
                else{
                    if(response.data === 'username unavailable'){
                        this.username_unavailable = true;
                        this.retry_axios = 1;
                        this.creating_link_in_bio = false;
                    }
                    else if(response.data === 'username contains invalid characters'){
                        this.username_invalid_characters = true;
                        this.retry_axios = 1;
                        this.creating_link_in_bio = false;
                    }
                    else{
                        this.$router.push('/dashboard/edit-link-in-bio/'+response.data); //redirect to link in bio editor
                        this.retry_axios = 1;
                        this.creating_link_in_bio = false; // Set to false after navigation completes
                    }
                }
            })
            .catch(function (error) {
            console.log(error);
            });
        },
        checkContentHeight() {
            this.$nextTick(() => {
                const contentHeight = document.body.scrollHeight;
                const windowHeight = window.innerHeight;

                // console.log('contentHeight: '+contentHeight+', windowHeight: '+windowHeight);

                if (contentHeight > windowHeight) {
                this.isButtonFixed = true;
                } else {
                this.isButtonFixed = false;
                }
            });
        }
      },
      watch: {
        links: {
            handler() {
                this.checkContentHeight();
            },
            deep: true // This tells Vue to watch for changes not only on the top-level property but also within its nested properties. It’s necessary when you want to watch changes within an array or object deeply.
        },
        username() {
            this.username_unavailable = false;
            this.username_invalid_characters = false;
        }
      },
      mounted() {
        this.$emit('updateprops');
        this.load_logos();
        window.addEventListener('resize', this.checkContentHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkContentHeight);
    },
    // do not forget this section
    directives: {
    ClickOutside
    }
    };
    </script>
  


// WEBPACK FOOTER //
// src/create-link-in-bio.vue